import { publicApi } from '../api';

export interface PublicCandidatoChallenge {
  challengeId: string;
  nonce: string;
  dificuldade: number;
}

export interface SalaProcessoCandidatoResponse {
  acessoSalaVirtualLiberado: boolean;
  mensagemSalaVirtual: string;
  salaVirtualUrl: string | null;
  dataHoraBancaVirtual: string | null;
  salaVirtualLiberadoEm: string | null;
  salaVirtualEditalNome: string | null;
  salaVirtualNumeroChamada: number | null;
  recursoDisponivel: boolean;
  recursoJaPreenchido: boolean;
  mensagemRecurso: string | null;
  recursoUrl: string | null;
  dataHoraBancaRecurso: string | null;
  recursoEditalNome: string | null;
  recursoNumeroChamada: number | null;
}

export default class CandidatoAcessoViewModel {
  static async obterChallenge(): Promise<PublicCandidatoChallenge> {
    const response = await publicApi.get<PublicCandidatoChallenge>('/public/candidato/challenge');
    return response.data;
  }

  static async consultarSalaProcesso(
    inscricao: string,
    documento: string,
    challengeId: string,
    challengeSolution: string
  ): Promise<SalaProcessoCandidatoResponse> {
    const response = await publicApi.post<SalaProcessoCandidatoResponse>(
      '/public/candidato/sala-processo',
      { inscricao, documento, challengeId, challengeSolution }
    );
    return response.data;
  }
}
